import { Location } from '../common/enums';

export const TUTORIAL_LOCATION_ONLINE = 'Online';
export const TUTORIAL_LOCATIONS = [...Object.values(Location), TUTORIAL_LOCATION_ONLINE] as const;

const listAttributes = [
  'tutorialId',
  'startDatetime',
  'course',
  'duration',
  'host',
  'description',
  'joinLink',
  'location',
  'capacity',
  'attendees',
  'linkedTutorials',
] as const;

const getAttributes = [...listAttributes] as const;

export const teacherUpdateAttributes = ['description', 'joinLink', 'capacity', 'location'] as const;

export const adminUpdateAttributes = [...teacherUpdateAttributes, 'host', 'attendees'] as const;

export const TutorialAttributes = {
  List: listAttributes,
  Get: getAttributes,
  TeacherUpdate: teacherUpdateAttributes,
  AdminUpdate: adminUpdateAttributes,
};
